import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { cleverTap, postFileData, s3FileUpload, uploadFile } from "../../../services/provider/common";
import Alert from "@mui/material/Alert";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import RefreshIcon from "@mui/icons-material/Refresh";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";
import { AppID, CLEVER_TAP_EVENTS, STATUS_CODE_MAP, URL, USER } from "../../../constants/provider/constant";
import { toast } from "react-toast";
import { MBContract } from "../../../constants/insurance/constant";
import { requestHistory } from "../../../services/provider/requestHistory";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DescriptionTwoToneIcon from "@material-ui/icons/DescriptionTwoTone";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { updateRequests } from "../../centralOms/common/apiCalls";
import axios from "axios";
import DownloadIcon from "@mui/icons-material/Download";

export default function SubmitDocumentsDialog({
  action,
  requestDetails,
  documentDialogVisible,
  setDocumentDialogVisibility,
  fetchData,
  setFetchData,
}) {
  const [notes, setNotes] = useState("");
  const [labReports, setLabReports] = useState([]);
  const [bills, setBills] = useState([]);
  const [reportGuid, setReportGuid] = useState(null);
  const [billGuid, setBillGuid] = useState(null);
  const [prevFiles, setPrevFiles] = useState(null);
  const [prevRep, setPrevRep] = useState(null);
  const [prevBills, setPrevBills] = useState(null);

  useEffect(() => {
    cleverTap(CLEVER_TAP_EVENTS.attachDocsPopupShown, {
      statusInfo: "Customer awaited at DC",
      requestID: requestDetails.id,
      visitType: requestDetails.visitType,
      testCategory: requestDetails.packageName,
    });
    if ([STATUS_CODE_MAP["Information Awaited"], STATUS_CODE_MAP["Partial Report Uploaded"]].includes(requestDetails.statusID)) {
      requestHistory(requestDetails.id)
        .then((res) => {
          if (res && res.isSuccess === true) {
            let prevFilesRF;
            if (requestDetails.statusID == STATUS_CODE_MAP["Partial Report Uploaded"]) {
              prevFilesRF = res.requestHistory.statusHistory.find((ele) => ele.statusId === 162);
            } else {
              prevFilesRF = res.requestHistory.statusHistory.find((ele) => ele.statusId === 161 || (ele.statusId === 37 && ele.attachedFiles));
            }
            if (prevFilesRF) setPrevFiles(prevFilesRF.attachedFiles);
          }
        })
        .catch((err) => console.error(err));
    }
  }, []);

  const handleFieldChange = async (event) => {
    event.preventDefault();
    const { name, value, files } = event.target;
    let res = {};
    if (files)
      for (let i = 0; i < Object.keys(files).length; i++) {
        let fileDetails = {
          type: files[i]?.type,
          fileName: files[i]?.name,
          signedUrl: "",
          fileIdentifier: "",
          fileType: "Report",
          appId: AppID,
          EntityRelationId: USER?.user?.entityId,
          s3AccountType: "MB",
          contractType: requestDetails.contractId,
        };
        let response = await uploadFile(fileDetails);

        if (response?.success) {
          let fileArr = new FormData();
          fileArr.append("Content-Disposition", '"form-data"');
          fileArr.append("name", '"file"');
          fileArr.append("FileCategory", '"Report"');
          fileArr.append("userName", '"Plus"');
          fileArr.append("FileType", '"Report"');
          fileArr.append("providerId", USER.user.providerId);
          fileArr.append("file", files[i.toString()]);
          fileDetails.file = files[i];
          fileDetails.signedUrl = response.signedURL;
          fileDetails.fileIdentifier = response.fileIdentifier;
          fileDetails.fileName = response.fileName;
          const newFile = new File([fileDetails.file], response?.fileName, { type: fileDetails.file.type });
          fileDetails.file = newFile;
          let s3Data = await s3FileUpload(files[i], response?.signedURL);
          if (s3Data?.status === 200 || s3Data === 200) {
            delete fileDetails.file;
            let data = await postFileData(fileDetails);
            let fileGuid = {};
            fileGuid[data?.fileIdentifier] = data?.fileName;
            res = {
              ...res,
              ...fileGuid,
            };
          }
        }
        if (!response?.success)
          cleverTap(name === "bills" ? CLEVER_TAP_EVENTS.uploadBillsFailed : CLEVER_TAP_EVENTS.uploadReportFailed, {
            srcPage: "documents/pending",
            statusInfo: "Customer awaited at DC",
            requestID: requestDetails.id,
            visitType: requestDetails.visitType,
            testCategory: requestDetails.packageName,
            isUploadSuccess: 0,
          });
      }
    let reports = [];
    if (event.target.files) {
      reports = Array.from(files);
    }
    switchCase(name, value, reports, res);
  };

  const submitDetails = async (submitNow) => {
    try {
      cleverTap(CLEVER_TAP_EVENTS.attachDocsFinalClick, {
        srcPage: "documents/pending",
        statusInfo: "Customer awaited at DC",
        requestID: requestDetails.id,
        visitType: requestDetails.visitType,
        testCategory: requestDetails.packageName,
      });
      const attachFiles = {
        reports: {
          ...reportGuid,
          ...(prevRep ? prevRep : {}),
        },
        bills: {
          ...billGuid,
          ...(prevBills ? prevBills : {}),
        },
      };
      let correctAction = submitNow ? action : "PartialReportUploaded";
      setDocumentDialogVisibility(false);
      if(Object.keys(attachFiles.reports).length === 0) {
        toast.error("No report uploaded");
        return;
      }
      let updateResponse = await updateRequests(["LABS"], [requestDetails.id], notes, correctAction, null, null, attachFiles);
      if (updateResponse?.success) {
        setFetchData(!fetchData);
        toast.success("Request updated successfully");
      } else {
        toast.error(`Request update failed - ${updateResponse?.error}`);
      }
    } catch (err) {
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  const closePopUp = () => {
    setDocumentDialogVisibility(false);
  };

  const switchCase = (name, value, files, guid) => {
    switch (name) {
      case "lab-reports":
        setLabReports(labReports.concat(files));
        setReportGuid({
          ...reportGuid,
          ...guid,
        });
        break;
      case "bills":
        setBills(bills.concat(files));
        setBillGuid({
          ...billGuid,
          ...guid,
        });
        break;
      default:
        break;
    }
  };

  const checKUpload = (type, name) => {
    let guidObj = type === "report" ? reportGuid : billGuid;
    for (let key in guidObj) {
      if (name === guidObj[key]) return true;
    }
    return false;
  };

  const reUploadSingleFile = async (fileDetails, data) => {
    const response = await uploadFile(fileDetails);
    if (response?.success) {
      fileDetails.file = data;
      fileDetails.signedUrl = response.signedURL;
      fileDetails.fileIdentifier = response.fileIdentifier;
      fileDetails.fileName = response.fileName;
      const myNewFile = new File([fileDetails.file], response?.fileName, { type: fileDetails.file.type });
      fileDetails.file = myNewFile;
      let fileArr = new FormData();
      fileArr.append("Content-Disposition", '"form-data"');
      fileArr.append("name", '"file"');
      fileArr.append("FileCategory", '"Report"');
      fileArr.append("userName", '"Plus"');
      fileArr.append("FileType", '"Report"');
      fileArr.append("providerId", USER.user.providerId);
      fileArr.append("file", data);
      let s3Data = await s3FileUpload(data, response?.signedURL);
      if (s3Data?.status === 200 || s3Data === 200) {
        delete fileDetails.file;
        let response = await postFileData(fileDetails);
        console.log(response);
        let fileGuid = {};
        fileGuid[response?.fileIdentifier] = response?.fileName;
        return fileGuid;
      }
    }
  };

  const reUpload = async (type, data) => {
    let fileDetails = {
      // file: files[i],
      type: data?.type,
      fileName: data?.name,
      signedUrl: "",
      fileIdentifier: "",
      fileType: "Report",
      appId: AppID,
      EntityRelationId: USER?.user?.entityId,
      s3AccountType: "MB",
      contractType: requestDetails.contractId,
    };
    let res = {
      ...(type === "report" ? reportGuid : billGuid),
      ...(await reUploadSingleFile(fileDetails, data)),
    };
    if (type === "report") setReportGuid(res);
    else setBillGuid(res);
  };

  const remove = (type, data, index, bool) => {
    let guidObj = type === "report" ? reportGuid : billGuid;
    if (bool)
      for (const key in guidObj) {
        if (guidObj[key] === data.name) {
          delete guidObj[key];
        }
      }

    let obj = type === "report" ? Array.from(labReports) : Array.from(bills);
    obj.splice(index, 1);
    type === "report" ? setLabReports(obj) : setBills(obj);
  };

  const clickedUpload = (e) => {
    if (e.target.id === "lab-reports")
      cleverTap(CLEVER_TAP_EVENTS.attachReportsClick, {
        srcPage: "documents/pending",
        statusInfo: "Customer awaited at DC",
        requestID: requestDetails.id,
        visitType: requestDetails.visitType,
        testCategory: requestDetails.packageName,
      });
    else
      cleverTap(CLEVER_TAP_EVENTS.attachBillsClick, {
        srcPage: "documents/pending",
        statusInfo: "Customer awaited at DC",
        requestID: requestDetails.id,
        visitType: requestDetails.visitType,
        testCategory: requestDetails.packageName,
      });
  };

  const reuseOldFiles = (data, type, evt) => {
    let files;
    let setter;
    if (type === "Report") {
      files = prevRep;
      setter = setPrevRep;
    } else {
      files = prevBills;
      setter = setPrevBills;
    }
    let obj = {};
    if (!evt.target.checked) {
      delete files[Object.keys(data)[0]];
      if (Object.keys(files).length == 0) setter(null);
      else setter(files);
    } else {
      obj = {
        ...files,
        ...data,
      };
      setter(obj);
    }
  };

  const downloadFile = async (guid) => {
    const config = {
      method: "get",
      url: `${URL.providercore_url}medibuddyCentral/downloadFile?guid=${guid}&providerId=${requestDetails.currentProvider}`,
      headers: {
        accesstoken: JSON.parse(localStorage.getItem("access_token")),
      },
    };
    const response = await axios(config);
    window.open(response.data.signedUrl);
  };

  return (
    <Dialog
      open={documentDialogVisible}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          closePopUp();
        } else return false;
      }}
      fullWidth={true}
      maxWidth={"sm"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">Submit Documents</span>
            <div className="text-xs text-gray-500">
              Request ID <span className="font-semibold">{requestDetails.id} </span>
            </div>
          </div>
          <div className="text-gray-500" onClick={closePopUp}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" onSubmit={(event) => submitDetails(event)}>
          <div className="pb-5">
            <Alert severity="error">
              <strong>
                Please upload reports/bills appropriately to avoid delay in processing as well as repeated requests for more information.{" "}
              </strong>
            </Alert>
            <div>
              <span className="text-sm text-gray-600"></span>
            </div>
          </div>

          {prevFiles && (
            <div className="flex justify-around">
              <div className="w-49-per">
                <div className="px-5 text-center">
                  <div className="z-20 ">
                    {prevFiles &&
                      Object.keys(prevFiles?.reports ?? {}).length > 0 &&
                      Object.keys(prevFiles.reports).map((elem, ind) => {
                        return (
                          <div key={ind} className="relative flex justify-between w-full rounded bg-sky-300">
                            <FormControlLabel
                              checked={prevRep?.[elem] ? true : false}
                              control={
                                <Checkbox
                                  onChange={(evt) => {
                                    reuseOldFiles({ [elem]: prevFiles.reports[elem] }, "Report", evt);
                                  }}
                                />
                              }
                              label={
                                <div className="justify-start w-full px-1">
                                  <span className="text-gray-600">
                                    <DescriptionTwoToneIcon style={{ fontSize: "18px" }} />
                                  </span>
                                  <span className="text-xs text-gray-700">{prevFiles.reports[elem]}</span>
                                </div>
                              }
                            />
                            <span className="text-gray-600 mt-2 cursor-pointer" onClick={() => downloadFile(elem)}>
                              <DownloadIcon style={{ fontSize: "25px" }} />
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="w-49-per">
                <div className="px-5 text-center">
                  <div className="z-20 ">
                    {prevFiles &&
                      Object.keys(prevFiles?.bills ?? {}).length > 0 &&
                      Object.keys(prevFiles.bills).map((elem, ind) => {
                        return (
                          <div key={ind} className="relative flex justify-between w-full rounded bg-sky-300">
                            <FormControlLabel
                              checked={prevBills?.elem ? true : false}
                              control={<Checkbox onChange={(evt) => reuseOldFiles({ [elem]: prevFiles.bills[elem] }, "Bills", evt)} />}
                              label={
                                <div className="justify-start w-full px-1">
                                  <span className="text-gray-600">
                                    <DescriptionTwoToneIcon style={{ fontSize: "18px" }} />
                                  </span>
                                  <span className="text-xs text-gray-700">{prevFiles.bills[elem]}</span>
                                </div>
                              }
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="flex justify-around py-5">
            <div className="w-49-per">
              <div className="p-5 text-center border-2 border-gray-400 border-dotted rounded m-aut0">
                <label htmlFor="lab-reports">
                  <div>
                    <FileUploadIcon></FileUploadIcon>
                  </div>
                  <div className="text-xs font-semibold text-gray-500 cursor-pointer">Attach Lab Reports</div>
                </label>
              </div>
              <div className="p-5 text-center rounded m-aut0">
                <div className="z-20 pt-5">
                  {labReports && labReports.length > 0 ? (
                    labReports.map((elem, ind) => {
                      let bool = checKUpload("report", elem.name);
                      return (
                        <div
                          key={ind}
                          className={
                            bool
                              ? "bg-green-100 rounded py-1 my-1 flex relative justify-between w-full"
                              : "bg-red-100 rounded py-1 my-1 flex relative justify-between w-full"
                          }
                        >
                          <div className="w-3/4 px-2 text-left">
                            <span className="text-gray-600">
                              <UploadFileIcon style={{ fontSize: "18px" }}></UploadFileIcon>
                            </span>
                            <span className="text-xs text-gray-700">{elem.name}</span>
                          </div>
                          <div className="flex w-1/4">
                            <div>
                              {bool ? (
                                <CheckIcon className="font-bold text-green-700" style={{ fontSize: "15px" }}></CheckIcon>
                              ) : (
                                <RefreshIcon className="text-gray-500 cursor-pointer" onClick={() => reUpload("report", elem)}></RefreshIcon>
                              )}
                            </div>
                            <div>
                              <CancelIcon
                                onClick={() => remove("report", elem, ind, bool)}
                                className="mx-2 text-red-600 cursor-pointer"
                                style={{ fontSize: "15px" }}
                              ></CancelIcon>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <></>
                  )}
                  {prevRep &&
                    Object.keys(prevRep).map((elem, ind) => {
                      return (
                        <div key={ind} className="relative flex justify-between w-full py-1 my-1 bg-green-100 rounded">
                          <div className="w-3/4 px-2 text-left">
                            <span className="text-gray-600">
                              <UploadFileIcon style={{ fontSize: "18px" }}></UploadFileIcon>
                            </span>
                            <span className="text-xs text-gray-700">{prevRep[elem]}</span>
                          </div>
                          <div className="flex w-1/4">
                            <div>
                              <CheckIcon className="font-bold text-green-700" style={{ fontSize: "15px" }}></CheckIcon>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <input
                type="file"
                id="lab-reports"
                className="hidden"
                multiple
                name="lab-reports"
                onClick={(e) => {
                  clickedUpload(e);
                }}
                onChange={(event) => handleFieldChange(event)}
              />
            </div>
            <div className="w-49-per">
              <div className="p-5 text-center border-2 border-gray-400 border-dotted rounded m-aut0">
                <label htmlFor="bills">
                  <div>
                    <FileUploadIcon></FileUploadIcon>
                  </div>
                  <div className="text-xs font-semibold text-gray-500 cursor-pointer">Attach Bills</div>
                </label>
              </div>
              <div className="p-5 text-center rounded m-aut0">
                <div className="pt-5">
                  {bills && bills.length > 0 ? (
                    bills.map((elem, ind) => {
                      let bool = checKUpload("bills", elem.name);
                      return (
                        <div
                          key={ind}
                          className={
                            bool
                              ? "bg-green-100 rounded py-1 my-1 flex relative justify-between w-full"
                              : "bg-red-100 rounded py-1 my-1 flex relative justify-between w-full"
                          }
                        >
                          <div className="w-3/4 px-2 text-left">
                            <span className="text-gray-600">
                              <UploadFileIcon style={{ fontSize: "18px" }}></UploadFileIcon>
                            </span>
                            <span className="text-xs text-gray-700">{elem.name}</span>
                          </div>
                          <div className="flex w-1/4">
                            <div>
                              {bool ? (
                                <CheckIcon className="font-bold text-green-700" style={{ fontSize: "15px" }}></CheckIcon>
                              ) : (
                                <RefreshIcon className="text-gray-500 cursor-pointer" onClick={() => reUpload("bills", elem)}></RefreshIcon>
                              )}
                            </div>
                            <div>
                              <CancelIcon
                                onClick={() => remove("bills", elem, ind, bool)}
                                className="mx-2 text-red-600 cursor-pointer"
                                style={{ fontSize: "15px" }}
                              ></CancelIcon>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <></>
                  )}
                  {prevBills &&
                    Object.keys(prevBills).map((elem, ind) => {
                      return (
                        <div key={ind} className="relative flex justify-between w-full py-1 my-1 bg-green-100 rounded">
                          <div className="w-3/4 px-2 text-left">
                            <span className="text-gray-600">
                              <UploadFileIcon style={{ fontSize: "18px" }}></UploadFileIcon>
                            </span>
                            <span className="text-xs text-gray-700">{prevBills[elem]}</span>
                          </div>
                          <div className="flex w-1/4">
                            <div>
                              <CheckIcon className="font-bold text-green-700" style={{ fontSize: "15px" }}></CheckIcon>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <input type="file" id="bills" className="hidden" multiple name="bills" onChange={(event) => handleFieldChange(event)} />
            </div>
          </div>

          <div className="pb-10">
            <FormControl className="w-full">
              <TextField
                sx={{ "& .MuiOutlinedInput-input, .MuiInputLabel-root": { fontSize: 14 } }}
                id="outlined-multiline-static"
                label="Remarks*"
                multiline
                name="notes"
                onChange={(event) => setNotes(event.target.value)}
                rows={4}
                value={notes}
              />
            </FormControl>
          </div>

          <div className="flex justify-between pb-5 text-center">
            <div
              className="w-40 p-1 text-sm font-semibold text-gray-900 border border-gray-600 rounded-md cursor-pointer"
              type="submit"
              variant="contained"
              size="large"
              onClick={closePopUp}
            >
              <span>Cancel</span>
            </div>
            {[MBContract["ESALES"], MBContract["PrePolicy"]].includes(requestDetails.contractId) &&
              requestDetails.statusID != STATUS_CODE_MAP["Partial Report Uploaded"] && (
                <div
                  className={`border text-gray-100 rounded-md w-40 p-1 text-sm ${
                    reportGuid && Object.keys(reportGuid).length > 0 && notes ? "cursor-pointer border-green-600 bg-green-600" : " bg-green-300 border-green-300"
                  }  font-semibold`}
                  type="submit"
                  variant="contained"
                  size="large"
                  onClick={reportGuid && Object.keys(reportGuid).length > 0 && notes ? () => submitDetails(false) : undefined}
                >
                  <span>Partial Upload</span>
                </div>
              )}
            <div
              className={`border text-gray-100 rounded-md w-40 p-1 text-sm ${
                ((reportGuid && Object.keys(reportGuid).length > 0) || prevRep) && notes ? "cursor-pointer border-green-600 bg-green-600" : " bg-green-300 border-green-300"
              }  font-semibold`}
              type="submit"
              variant="contained"
              size="large"
              onClick={((reportGuid && Object.keys(reportGuid).length > 0) || prevRep) && notes ? () => submitDetails(true) : undefined}
            >
              <span>Submit</span>
            </div>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
